import { IsNumber, IsOptional, IsString, IsUUID, Min } from 'class-validator';

export class CreateCompraAsistidaDto {
  @IsUUID()
  cliente_id: string;

  @IsOptional()
  @IsString()
  descripcion_libre?: string;

  @IsOptional()
  @IsString()
  url_producto_china?: string;

  @IsOptional()
  @IsString()
  proveedor_china?: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  monto_producto_usd?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  monto_servicio_gs?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  monto_logistica_gs?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  monto_comision_gs?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  cotizacion_usd_gs?: number;
}
